import { StyleSheet } from "react-native";
import { appColors, appFonts } from "../../appTheme";



export const BillingStyle = StyleSheet.create({
    container:{
        flex:1,
        backgroundColor:appColors.lightBackgroundColor
    },
    viewStyle:{
        flexDirection: 'row', 
        backgroundColor: appColors.light 
    },
    editIcon:{ 
        borderWidth: 1, 
        borderRadius: 11, 
        padding: 8, 
        marginHorizontal: 2, 
        borderColor: appColors.light, 
        backgroundColor: appColors.lightBackgroundColor,
     },
     deleteIcon:{ 
        borderWidth: 1, 
        borderRadius: 11, 
        padding: 8, 
        marginHorizontal: 2, 
        borderColor: appColors.light, 
        backgroundColor: appColors.lightBackgroundColor
     },
     iconView: {
        alignItems: 'flex-end'
    },
    tabFlex:{
        flex:0.5
    },
    contentTextStyle:{
        paddingTop:5
    },
    contentStyle:{
        fontFamily: appFonts.medium, 
        paddingTop: 10 
    },
    column:{
        flexDirection:'column'
    },
    cardStyle:{
        elevation: 0, 
        borderColor: 'transparent', 
        borderRadius: 10 
    },
    cardContentView:{
        flexDirection: 'row', 
        marginTop: 5, 
        justifyContent: 'space-between' 
    },
    renderView:{
        flexDirection: 'row', 
        justifyContent: 'space-between' 
    },
    dividerStyle:{
        paddingVertical: 5 
    },
    selectedTab:{
        justifyContent: 'center', 
        alignItems: 'center', 
        backgroundColor: appColors.lightBackgroundColor, 
        left: 20 
    },
    tabIndicator:{
        width: 70, 
        backgroundColor: appColors.primary, 
        height: 2 
    },
    unselectedTab:{
        justifyContent: 'center', 
        alignItems: 'center', 
        backgroundColor: appColors.light, 
    },
    tabNonIndicator:{
        backgroundColor: appColors.lightPrimary, 
        height: 2, 
        left: 6 
    },
    tabView:{
        marginRight: 20, 
        marginLeft: 8, 
        paddingTop: 20, 
        paddingBottom: 15, 
        marginTop: 5, 
        borderTopRightRadius: 26, 
        borderTopLeftRadius: 26, 
    }
})